// Downloads Search Bar Component
// Simple search input for filtering downloads

import './DownloadsSearchBar.css';

export function DownloadsSearchBar({
  searchTerm,
  onSearchChange,
  onSubmit,
  placeholder = "Search downloads...",
  className = ''
}) {
  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && onSubmit) {
      onSubmit(searchTerm);
    }
  };


  return (
    <div className={`downloads-search-bar ${className}`}>
      <div className="search-input-container">
        <i className="fa-solid fa-search search-icon" aria-hidden></i>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder={placeholder}
          className="search-input"
        />
      </div>
    </div>
  );
}